const helpData = [
  {
    index: "전체",
    items: [],
  },
  {
    index: "메일",
    items: [
      {
        Q: `메일 수신 확인`,
        A: `메일이 도착하면 오른쪽 하단에 새 메일이 도착했다는 내용의 팝업창이 나타나며, 오른쪽 상단 <b>[메일함]</b> 아이콘과 <b>[메일함]</b> 화면 왼쪽 <b>[받은 메일]</b>에 확인하지 않은 메일의 숫자가 나타납니다.<br /><br />
        팝업창은 <b>[ X ]</b> 버튼을 클릭하지 않으면 4초 후 자동으로 사라집니다.`,
      },
      {
        Q: `메일 내용 확인`,
        A: `오른쪽 상단 <b>[메일함]</b> 아이콘을 클릭하면 메일 목록을 확인할 수 있는 화면으로 전환되며, 왼쪽 일 목록 중 메일 제목을 클릭하면 메일 내용을 확인할 수 있습니다.`,
      },
      {
        Q: `메일 회신`,
        A: `메일에서 회신을 요청하는 경우 메일 내용 위 <b>[회신]</b> 버튼을 클릭하여 보기를 선택할 수 있습니다. <b>[회신]</b> 버튼 클릭 후 각 항목에 대해 체크한 후 <b>[보내기]</b> 버튼을 누르면 회신이 완료됩니다.<br /><br />
        ※ <b>[회신]</b> 화면에서 <b>[보내기]</b> 또는 <b>[임시저장]</b> 버튼을 클릭하지 않고 메일함을 닫거나 다른 메일을 여는 경우 해당 메일에서 체크한 내용이 초기화되니 유의하시기 바랍니다.`,
      },
      {
        Q: `메일 임시저장`,
        A: `메일 회신 화면에서 <b>[임시저장]</b> 버튼을 클릭하고, 임시 저장 진행 여부를 묻는 팝업에서 <b>[네]</b>를 클릭하면 본인이 선택한 보기에 체크된 상태로 <b>[임시 보관]</b>에 저장됩니다. 임시 저장한 메일은 <b>[임시 보관]</b>에서만 수정 및 보내기가 가능합니다.<br /><br />
        ※ 임시 보관함에 남아 있는 메일은 회신한 메일로 인정되지 않으므로 평가 종료 전 <b>[임시 보관]</b>에 남은 메일이 없는지 확인하시기 바랍니다.`,
      },
    ],
  },
  {
    index: "보고서",
    items: [
      {
        Q: `보고서 창`,
        A: `오른쪽 상단의 <b>[보고서]</b> 아이콘을 클릭하면 팝업 형태의 창으로 제시되며, 화면 위에서 좌우로 이동이 가능합니다.`,
      },
      {
        Q: `보고서 작성 및 수정`,
        A: `작성할 <b>[해결과제]</b> 목록을 클릭한 후 내용을 작성할 수 있습니다. <b>[보고서]</b> 팝업 시 다양한 편집 기능(글꼴, 자동 말머리 기호, 표 삽입)을 사용할 수 있습니다.<br /><br />
        ※ 작성 시 보안프로그램 작동으로 인해 마우스 오른쪽 버튼과 버튼과 <b>Ctrl</b>/<b>Alt</b>/<b>Shift</b>를 활용한 기능(복사, 붙여넣기, 자르기 등)은 사용이 불가합니다.`,
      },
      {
        Q: `보고서 저장`,
        A: `보고서 작성 중 <b>[ < ]</b> 뒤로가기 버튼이나 <b>[ X ]</b> 종료 버튼을 클릭해도 입력한 내용이 자동으로 저장됩니다.`,
      },
      {
        Q: `보고서 제출`,
        A: `보고서 작성을 완료한 후 <b>[ < ]</b> 뒤로가기 버튼을 클릭하여 보고서 제목 오른쪽에 있는 <b>[제출하기]</b> 버튼을 클릭하면 최종 제출 확인창이 팝업되며, <b>[제출]</b>을 클릭하면 보고서를 최종 제출할 수 있습니다.<br />
        보고서가 제출되면 해결과제 제목 오른쪽 상태 표시가 <b>[제출완료]</b>로 변경됩니다. 이를 통해 제출 여부를 확인할 수 있으며 <b>[할 일]</b>에도 즉시 반영됩니다.`,
      },
    ],
  },
  {
    index: "메신저",
    items: [
      {
        Q: `메신저 수신 확인`,
        A: `메신저가 도착하면 오른쪽 하단에 새 메신저가 도착했다는 내용의 팝업창이 나타나며, 오른쪽 상단 <b>[메신저]</b> 버튼에 확인하지 않은 메신저의 숫자가 나타납니다.<br /><br />
        팝업창은 <b>[ X ]</b> 버튼을 클릭하지 않으면 4초 후 자동으로 사라집니다.`,
      },
      {
        Q: `메신저 창`,
        A: `<b>[메신저]</b>는 오른쪽 상단의 <b>[메신저]</b> 아이콘을 클릭하면 팝업 형태의 창으로 제시되며, 좌우로 이동이 가능합니다.`,
      },
      {
        Q: `선택형 답변방식`,
        A: `메신저에서 보기를 제시하는 경우 보기를 클릭하여 답변할 수 있으며, 선택한 내용은 회색 말풍선으로 "질문에 대한 답장" 문구와 함께 표시됩니다.<br /><br />
        선택한 내용은 제한 시간 내에서 보기를 새로 클릭하여 재답변할 수 있습니다. 다음 메신저가 전달된 이후에도 변경이 가능합니다. 가장 마지막에 선택한 내용이 최종 답장으로 처리됩니다.`,
      },
      {
        Q: `입력형 답변방식`,
        A: `메신저에서 보기 없이 질문한 제시하는 경우 해당 메신저 오른쪽의 <span style="color: #09183A; font-weight:600;">남색 <b>[답장]</b> 버튼</span>을 클릭하여 답장할 수 있습니다.<br />
        <b>[답장]</b> 버튼 클릭 시 메신저 하단 입력창에 "질문에 대한 답장" 문구가 표시되며 답변을 입력할 수 있게 활성화됩니다. 답변을 입력한 후에는 <span style="color: #09183A; font-weight:600;">오른쪽 남색 화살표</span>를 클릭하여 답장할 수 있습니다.<br /><br />
        제한 시간 내에 <b>[답장]</b> 버튼을 클릭하여 새로 입력할 수 있으며, 다음 메신저가 전달된 이후에도 새로 입력할 수 있습니다. 가장 마지막에 응답한 내용이 최종 응답으로 처리됩니다.<br /><br />
        ※ 글 입력 후 엔터키를 눌러도 답장이 전송되지 않으므로 반드시 <span style="color: #09183A; font-weight:600;">오른쪽 남색 화살표</span>를 클릭하시고 말풍선의 형태로 답장이 제출되었는지 확인하시기 바랍니다.`,
      },
    ],
  },
  {
    index: "자료실",
    items: [
      {
        Q: `폴더`,
        A: `요청사항을 해결하기 위한 자료는 오른쪽 상단 <b>[자료실]</b> 아이콘을 클릭하여 확인할 수 있습니다. 각 자료는 왼쪽에 Folders로 구분되어 있으며, 각 폴더 명칭을 클릭하여 해당 폴더 내의 자료를 확인할 수 있습니다.<br /><br />
        할 일을 해결하기 위해 어떤 폴더의 자료를 참고해야 하는지 메일 내용을 통해 확인할 수 있으며, 필요한 폴더는 메일이 도착함과 동시에 자동으로 나타납니다.<br /><br />
        ※ 보안 폴더의 비밀번호는 해당 자료 활용을 지시하는 메일에 4자리 숫자로 제시되니 참고하시기 바랍니다.`,
      },
      {
        Q: `중요문서 등록 및 해제`,
        A: `중요문서 등록 기능은 자료의 중요도를 표시할 수 있게 하여 자료 파악의 편의를 지원하는 기능입니다.<br /><br />
        <b>[자료실]</b>홈 페이지 <b>[File List]</b>에서 자료명 왼쪽 <b>[북마크]</b>를 클릭하거나 자료 화면의 자료명 오른쪽 끝 <b>[북마크]</b>를 클릭해도 중요문서로 등록할 수 있으며, 중요문서로 등록된 자료는 <b>[북마크]</b>가 남색으로 표시됩니다.<br /><br />
        중요문서 해제는 등록된 자료의 <b>[북마크]</b>를 다시 클릭하면 <b>[북마크]</b>가 회색으로 표시되며 해제됩니다.`,
      },
      {
        Q: `자료실 탭 기능`,
        A: `<b>[자료실]</b>의 탭 기능은 <b>[자료실]</b> 내에서 여러 자료를 동시에 열 수 있게 하여 자료 파악의 편의를 지원하는 기능입니다.<br />
        <b>[자료실]</b> 홈에서 자료 제목을 클릭하면 자료 탭이 자동으로 추가되며, 최대 20개 탭까지 지원합니다.<br />
        각 탭의 <b>[ X ]</b> 버튼을 클릭하면 해당 탭을 당을 수 있으며, 자료실 홈 탭은 닫히지 않습니다.<br /><br />
        ※ 각 자료 탭이 아닌 <b>[자료실]</b> 창을 닫는 경우 추가한 탭이 유지되지 않으니 유의하시기 바랍니다.`,
      },
    ],
  },
  {
    index: "메모장",
    items: [
      {
        Q: `메모장 창`,
        A: `<b>[메모장]</b>은 오른쪽 상단의 <b>[메모장]</b> 아이콘을 클릭하면 팝업 형태의 창으로 제시되며, <b>[메일함]</b>, <b>[자료실]</b> 화면 위에서 좌우로 이동이 가능합니다.<br /><br />
        ※ 평가 중 별도의 종이를 사용하는 것은 부정행위로 처리되니 VAC 프로그램 내 <b>[메모장]</b>을 활용하시기 바랍니다.`,
      },
      {
        Q: `메모 작성`,
        A: `오른쪽 상단의 <b>[메모장]</b> 아이콘을 클릭하고 <b>[메모장]</b> 창에서 왼쪽 상단 "메모 작성" <b>[ + ]</b> 버튼을 클릭하면 새로운 메모를 작성할 수 있으며, 메모 입력 창에서는 메모의 제목과 내용을 입력할 수 있습니다.<br /><br />
        메모는 별도의 저장 버튼 없이 <b>[ < ]</b> 뒤로 가기 버튼이나 <b>[ X ]</b> 종료 버튼을 클릭해도 입력한 내용이 자동으로 저장됩니다.<br /><br />
        ※ 작성 시 보안프로그램 작동으로 인해 마우스 오른쪽 버튼과 <b>[Ctrl]</b>, <b>[Alt]</b>, <b>[Shift]</b>를 활용한 기능(복사, 붙여넣기, 자르기 등)은 사용이 불가합니다.`,
      },
      {
        Q: `메모 삭제`,
        A: `메모 리스트에서 <b>[쓰레기통 모양]</b> 버튼을 클릭하면 해당 메모를 삭제할 수 있습니다.`,
      },
      {
        Q: `메모 검색`,
        A: `메모 리스트 상단 검색창에서 작성한 메모의 제목을 검색할 수 있습니다.`,
      },
    ],
  },
  {
    index: "계산기",
    items: [
      {
        Q: `계산기 창`,
        A: `<b>[계산기]</b>는 오른쪽 상단의 <b>[계산기]</b> 아이콘을 클릭하면 팝업 형태의 창으로 제시되며, <b>[메일함]</b>, <b>[자료실]</b> 화면 위에서 좌우로 이동이 가능합니다.<br /><br />
        ※ 평가 중 별도의 종이를 사용하는 것은 부정행위로 처리되니 VAC 프로그램 내 <b>[계산기]</b>를 활용하시기 바랍니다.`,
      },
      {
        Q: `계산기 유의사항`,
        A: `작성 시 보안프로그램 작동으로 인해 마우스 오른쪽 버튼과 <b>[Ctrl]</b>, <b>[Alt]</b>, <b>[Shift]</b>를 활용한 기능(복사, 붙여넣기, 자르기 등)은 사용이 불가합니다.<br /><br />
        ※ <b>[Delete]</b>, <b>[Shift]</b> 등의 버튼을 사용할 수 없어 괄호 사용이 불가능하므로 참고하시기 바랍니다.
        `,
      },
    ],
  },
  {
    index: "기타",
    items: [
      {
        Q: `화면분할`,
        A: `화면 오른쪽 상단의 <b>[화면분할]</b> 버튼을 클릭하면 화면이 좌・우 페이지로 분리되어 한 화면에서 여러 내용을 확인할 수 있습니다.<br />
        화면분할은 <b>[메일함]</b>과 <b>[자료실]</b>만 가능합니다.<br />
        <b>[화면분할]</b> 버튼을 재클릭하면 화면분할 기능을 해제하여 넓은 화면으로 사용하실 수 있습니다.`,
      },
      {
        Q: `감독위원 채팅`,
        A: `
        특이사항 및 문의사항 발생 시 화면 오른쪽 상단의 응시자 성명을 클릭하면 감독위원과 채팅할 수 있습니다.<br /><br />
        ※ 해당 채팅창은 과제 요청사항 해결 중 사용하는 <b>[메신저]</b> 기능과 별개의 기능으로 평가에 포함되는 내용이 아니므로 유의하시기 바랍니다.
        `,
      },
      {
        Q: `평가 시간`,
        A: `
        왼쪽 상단의 일자와 시간은 가상의 일자와 시간을 제시하고 있으며 평가 진행 중 일자와 시간을 확인할 수 있으며 실제 일자, 시간과는 무관합니다.<br /><br />
        평가는 3시간 동안 진행되며, <b>13:10:00</b>에 시작하여 <b>16:10:00</b>에 종료됩니다.<br /><br />
        ※ 해당 시계는 현재 진행 중인 시간으로 남은 평가 시간이 아니므로 유의하시기 바랍니다.
        `,
      },
      {
        Q: `평가 잔여시간 알림`,
        A: `
        평가 진행 중 오른쪽 하단 팝업 알림창을 통해 과제별 잔여 시간 알림이 팝업되며, 각 수행 과제별 종료 20분 전, 10분 전, 3분 전, 1분 전 팝업 알림이 나타납니다.<br /><br />
        팝업창은 <b>[ X ]</b> 버튼을 클릭하지 않으면 4초 후 자동으로 사라집니다.<br /><br />
        과제 종료 5분 전인 <b>16:05:00</b>부터는 왼쪽 상단의 시간이 빨간색으로 변경됩니다.
        `,
      },
      {
        Q: `평가 종료 시간 및 알림`,
        A: `
        왼쪽 상단에 제시된 시각이 <b>16:10:00</b>가 되는 순간 평가가 종료되며, <b>[종료]</b> 버튼을 클릭하지 않아도 자동으로 업무가 종료됩니다.<br /><br />
        종료 후에는 감독위원의 최종 확인을 위한 대기 화면이 나타나며, 이후 <b>[평가 종료]</b> 버튼이 나타나면 VAC가 정상적으로 완료된 것을 의미합니다. 해당 버튼을 클릭하면 VAC 프로그램이 자동으로 종료됩니다.<br /><br />
        전체 평가 종료 5분 전 즉, <b>16:05:00</b>부터는 왼쪽 상단에 제시된 시각이 빨간색으로 전환됩니다. 평가 시간 관리에 참고하시기 바랍니다.  
        `,
      },
      {
        Q: `할 일 기능`,
        A: `
        왼쪽 상단의 <b>[할 일]</b> 버튼을 클릭하면 해결해야 할 업무를 확인할 수 있습니다. <b>[할 일]</b>은 평가 진행 중 제시된 업무를 해결할 때마다 실시간으로 반영되며 본인의 과제 진행 현황을 확인할 수 있습니다.
        `,
      },
      {
        Q: `종료 기능`,
        A: `
        전체 평가 종료 45분 전<b>(15:25:00)</b>부터 왼쪽 상단에 <b>[종료]</b> 버튼이 활성화되며, <b>[종료]</b> 버튼을 클릭하면 VAC 프로그램의 종료가 가능합니다. 평가 종료 전 <b>[종료]</b> 버튼을 클릭하면 종료 여부를 묻는 팝업이 나타나고 <b>[네]</b>를 클릭하면 종료됩니다.<br /><br /> 
        완료되지 않은 업무가 남아있는 상황에서 종료 버튼 클릭 시 이에 대한 확인 팝업이 나타나고, 그럼에도 종료를 원하실 경우 <b>[네]</b>를 클릭하여 종료할 수 있습니다.<br /><br />
        ※ <b>[할 일]</b>이 남아있는 상태에서 VAC 프로그램 종료 시 발생되는 불이익에 대해서는 책임지지 않으며, VAC 프로그램 종료 후에는 재접속이 불가능하므로 유의하시기 바랍니다.
        `,
      },
      {
        Q: `도움말 기능`,
        A: `
        왼쪽 상단의 <b>[도움말]</b> 버튼을 클릭하면 평가 중 VAC 프로그램의 기능에 대한 궁금증을 해결할 수 있습니다.<br /> 
        <b>[도움말]</b>은 기능별로 간략하게 설명되어 있으며 추가적으로 기능에 대한 문의나 도움이 필요할 경우 오른쪽 상단의 응시자 성명을 클릭하여 채팅을 통해 감독위원에게 문의하시기 바랍니다.
        `,
      },
    ],
  },
];

export default helpData;
